import { useState } from 'react';
import { CtPlatformImportType } from '../models/general';

export interface CardItem {
  title?: string;
  type?: CtPlatformImportType;
  desc?: string;
  icon?: React.ReactElement;
  isRecommended?: boolean;
  isActive?: boolean;
}

export interface CardProps {
  items: CardItem[];
  onClick: (item: CardItem) => void;
}

function Card(props: CardProps) {
  const [activeItem, setActiveItem] = useState({});

  const handleClick = (item: CardItem) => {
    setActiveItem(item);
    props.onClick(item);
  };

  return (
    <div className="ct_cards">
      {props.items.map((item, index) => (
        <div key={index} className="ct_cards-item" aria-hidden onClick={() => handleClick(item)}>
          <div className={`ct_card ${activeItem === item ? '_active' : ''}`}>
            <div className="ct_card-image">{item.icon}</div>
            <div className="ct_card-title">{item.title}</div>
            <div className="ct_card-desc">{item.desc}</div>
            <div className="ct_card-footer">
              {item.isRecommended ? <div className={`ct_card-pill _primary ${item.isActive ? '_selected' : ''}`}>Recommended</div> : ''}
              <span className="ct_card-link">Choose</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

Card.defaultProps = { ...{} };

export default Card;
